import React, { useState } from "react"
import { Helmet } from "react-helmet"
import { Card, CardBody, Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import List from "./List"
function AdvList() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "List",
      link: "/businesses&services/list",
    },
    paths: [
      {
        label: "Businesses & Services",
        link: "/businesses&services/list",
      },
    ],
  }
  return (
    <React.Fragment>
      <Helmet>
        <title>Businesses & Services List | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />
          <Card>
            <CardBody>
              <List />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AdvList
